import { render } from "./LicenseMessage.vue?vue&type=template&id=67ba7405&scoped=true&ts=true"
import script from "./LicenseMessage.vue?vue&type=script&lang=ts"
export * from "./LicenseMessage.vue?vue&type=script&lang=ts"

import "./LicenseMessage.vue?vue&type=style&index=0&id=67ba7405&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ba7405"]])

export default __exports__